export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.10-1539.25",
  commitId: "bc55d9641b5f02fec1eb6c965af24feba94144cb",
  commitTime: "2026-07-10T15:39:25.000Z",
});
